import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient.js';
import InvitationsRow from './InvitationsRow.jsx';
import ExcelExportButton from '../../assets/ExcelExportButton.jsx';
import Loader from '../../assets/tools/Loder/loader';

const Invitations = () => {
  const [invitations, setInvitations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [invitationsPerPage] = useState(50);
  const [filter, setFilter] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortOrder, setSortOrder] = useState('asc'); // Default sorting order

  const fetchData = async () => {
    try {
      const response = await AxiosClient.get('/invitations');
      setInvitations(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString()); // Default: current year

  useEffect(() => {
    fetchData();
  }, []);

  const handleDeleteArt = async (id) => {
    try {
      await AxiosClient.delete(`/invitations/${id}`);
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };
 // Extract unique years from `expired_at`
 const availableYears = Array.from(
  new Set(invitations.map((inv) => new Date(inv.expired_at).getFullYear()))
).sort((a, b) => b - a); // Sort years descending


  const handleFilter = (status) => {
    setFilter(status);
    setSearchTerm('');
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setFilter(null);
  };

  
  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  // Apply filters
  let filteredInvitations = invitations;
  if (filter === 'pending') {
    filteredInvitations = invitations.filter((invitation) => invitation.status === 'pending');
  } else if (filter === 'accepted') {
    filteredInvitations = invitations.filter((invitation) => invitation.status === 'accepted');
  }

  // Apply search filter
  filteredInvitations = filteredInvitations.filter((invitation) =>
    invitation.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

 
  if (selectedYear) {
    filteredInvitations = filteredInvitations.filter(
      (inv) => new Date(inv.expired_at).getFullYear().toString() === selectedYear
    );
  }
  

  const indexOfLastInvitation = currentPage * invitationsPerPage;
  const indexOfFirstInvitation = indexOfLastInvitation - invitationsPerPage;
  const currentInvitations = filteredInvitations.slice(indexOfFirstInvitation, indexOfLastInvitation);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div className="m-3">
        {/* Buttons for filter */}
        <button className="btn btn-success m-2" onClick={() => handleFilter('pending')}>
          Show Active
        </button>
        <button className="btn btn-warning m-2" onClick={() => handleFilter('accepted')}>
          Show Passed
        </button>
        <Link to="./Add" className="btn btn-info m-2">
          Generate Code
        </Link>
        <Link to="./Add/excel" className="btn btn-dark m-2">
          Generate Code Via Excel
        </Link>

        {/* Search input */}
        <div className="input-group input-group-outline mb-3">
          <input
            type="text"
            placeholder="Search by title..."
            value={searchTerm}
            onChange={handleSearch}
            className="form-control m-2"
          />
        </div>

       {/* Year Filter Dropdown */}
       <div className="mb-3">
          <label className="me-2">Filter by Year:</label>
          <select value={selectedYear} onChange={handleYearChange} className="form-select w-auto d-inline-block">
            <option value="">All Years</option>
            {availableYears.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>

        {/* Export all filltered invitations (without pagenation) */}
        <ExcelExportButton data={filteredInvitations} fileName="invitations" />
      </div>

      <div className="card-body px-0 pb-2">
        <div className="p-0 text-center border">
          {loading ? (
            <Loader label="Loading invitations..." />
          ) : (
            <table className="table align-items-center justify-content-center mb-0">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Code</th>
                  <th>Status</th>
                  <th>User Used</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentInvitations.map((invit_item) => (
                  <InvitationsRow
                    key={invit_item.id}
                    title={invit_item.title}
                    invitation_code={invit_item.invitation_code}
                    user={invit_item.user}
                    status={invit_item.status}
                    expired_at={invit_item.expired_at}
                    id={invit_item.id}
                    onDelete={handleDeleteArt}
                  />
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Pagination */}
        <nav>
          <ul className="pagination m-2 p-2">
            {Array.from({ length: Math.ceil(filteredInvitations.length / invitationsPerPage) }).map((_, index) => (
              <li key={index} className={`page-item m-2 ${currentPage === index + 1 ? 'font-bold' : ''}`}>
                <button className="page-link" onClick={() => paginate(index + 1)}>
                  {index + 1}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Invitations;
